import { render, staticRenderFns } from "./ProjectChangesListCard.vue?vue&type=template&id=380d1b5e&scoped=true"
import script from "./ProjectChangesListCard.vue?vue&type=script&lang=js"
export * from "./ProjectChangesListCard.vue?vue&type=script&lang=js"
import style0 from "./ProjectChangesListCard.vue?vue&type=style&index=0&id=380d1b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d1b5e",
  null
  
)

export default component.exports